import { dispatch } from '@rematch/core';
import jwt_decode from 'jwt-decode';
import { store } from '../state';

class ServiceProxy {

    constructor(service, app, isAccountOnly) {
        this.service = service;
        this.app = app;
        this.isAccountOnly = isAccountOnly
    }

    async autheticate() {
        const token = localStorage.getItem('feathers-jwt');
        const jwt = jwt_decode(token);
        const isExpired = Date.now() >= (jwt.exp * 1000 - 5000);
        if (isExpired) {
            try {
              const response = await fetch(`${process.env.REACT_APP_SOCKET_SERVER_URL}/auth/refresh`, {
                method: "POST",
                credentials: "include"
              });
              if (!response || !response.ok) throw new Error("Refresh failed");
                const data = await response.json();
                await this.app.authenticate({
                strategy: 'jwt',
                accessToken: data.accessToken
                });
            } catch (e) {
              localStorage.removeItem("feathers-jwt")
            }
          } else if(!store.getState().error.authCalled){
            await this.app.authenticate();
            dispatch.error.setAuthCalled(true);
        }
    }

    setBoundaryParameterInQuery(params) {
        const appData = store.getState().app;
        if (!params.query) {
            params.query = {}
        }
        if (!params.query.isPublic) {
            if (appData.selectedAccount && !params.query.accountCheckNotRequired) {
                params.query.accountId = appData.selectedAccount._id;
            }
            if (!params.accountOnly && !this.isAccountOnly && appData.selectedOrganisation && !params.query.accountCheckNotRequired) {
                params.query.organizationId = appData.selectedOrganisation.id
            }
        }

            

        delete params.query.isPublic;

        
    }

    async create(...args) {
        await this.autheticate();
        return this.service.create(...args);
    }

    async find(params = {}) {
        await this.autheticate();

        this.setBoundaryParameterInQuery(params);
        return this.service.find(params);
    }

    async get(id, params = {}) {
        await this.autheticate();

        this.setBoundaryParameterInQuery(params);
        return this.service.get(id, params);
    }

    async patch(id, data, params = {}) {
        await this.autheticate();

        this.setBoundaryParameterInQuery(params);
        return this.service.patch(id, data, params);
    }

    async remove(id, params = {}) {
        await this.autheticate();

        this.setBoundaryParameterInQuery(params);
        return this.service.remove(id, params);
    }

    async update(id, data, params = {}) {
        await this.autheticate();

        this.setBoundaryParameterInQuery(params);
        return this.service.update(id, data, params);
    }

    getService() {
        return this.service;
    }
}

export default class ServiceProxyFactory {

    constructor(app) {
        this.app = app;
    }

    getProxy(servicePath, isAccountOnly = false) {
        const service = this.app.service(servicePath);
        return new ServiceProxy(service, this.app, isAccountOnly);
    }
}


